import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { DEFAULT_API_CONFIG, TENANT_API_ENDPOINT } from '../utils/constants';

interface UpdateUserReportTeamsProps {
  userId: string;
  reportTeams: string[];
}

interface UpdateUserReportDeselectedCoursesProps {
  userId: string;
  reportDeselectedCourses: string[];
}

export const usersApi = createApi({
  reducerPath: 'usersApi',
  // TODO: Figure out why we can't pass in the DEFAULT_API_CONFIG object into fetchBaseQuery directly
  baseQuery: fetchBaseQuery({
    baseUrl: DEFAULT_API_CONFIG.baseURL,
    timeout: DEFAULT_API_CONFIG.timeout,
    headers: DEFAULT_API_CONFIG.headers,
  }),
  endpoints: (builder) => ({
    updateUserReportTeams: builder.mutation<IUser, UpdateUserReportTeamsProps>({
      query: ({ userId, reportTeams }) => {
        return {
          url: `${TENANT_API_ENDPOINT}/authed/users/${userId}/reportTeams`,
          method: 'PUT',
          body: { reportTeams },
        };
      },
    }),
    updateUserReportDeselectCourses: builder.mutation<
      IUser,
      UpdateUserReportDeselectedCoursesProps
    >({
      query: ({ userId, reportDeselectedCourses }) => {
        return {
          url: `${TENANT_API_ENDPOINT}/authed/users/${userId}/reportDeselectedCourses`,
          method: 'PUT',
          body: { reportDeselectedCourses },
        };
      },
    }),
  }),
});

export const { useUpdateUserReportTeamsMutation, useUpdateUserReportDeselectCoursesMutation } =
  usersApi;
